// 앱 채널 판별: 원스토어 등급용 Android TWA 앱(com.tllhouse.dungeonhero)이 이 웹을 감싼다.
// 앱 안에서는 웹 PG(포트원/KG이니시스) 결제를 보이면 안 되고(스토어 인앱결제 정책, docs/IAP-PRD.md §3),
// TWA가 Custom Tabs/WebView로 폴백해 UA에 "; wv)"가 붙어도 외부 브라우저 탈출을 하면 안 된다.
// 판정 함수는 순수(DOM 없음). getAppChannel()만 브라우저 값을 읽어 한 번 계산하고 캐시한다.

export type AppChannel = 'onestore-twa' | 'web';

export const APP_PACKAGE = 'com.tllhouse.dungeonhero';
export const APP_CHANNEL_KEY = 'dh.appChannel';

export interface AppChannelInput {
  /** location.search */
  search?: string;
  /** document.referrer */
  referrer?: string;
  /** 앞서 저장해 둔 값(sessionStorage) */
  stored?: string | null;
}

export function detectAppChannel(i: AppChannelInput): AppChannel {
  if (i.stored === 'onestore-twa') return 'onestore-twa';
  try {
    if (new URLSearchParams(i.search ?? '').get('source') === 'twa') return 'onestore-twa';
  } catch { /* 잘못된 쿼리는 웹으로 */ }
  // 정확 일치: 패키지명 뒤가 끝이거나 '/'일 때만(com.tllhouse.dungeonheroX 같은 다른 패키지는 웹)
  const ref = i.referrer ?? '', pre = 'android-app://' + APP_PACKAGE;
  if (ref.startsWith(pre) && (ref.length === pre.length || ref[pre.length] === '/')) return 'onestore-twa';
  return 'web';
}

let cached: AppChannel | null = null;

/** 브라우저 쪽: 한 번 계산해 캐시하고, 앱으로 판정되면 sessionStorage에 남겨 이동·새로고침 뒤에도 유지한다 */
export function getAppChannel(): AppChannel {
  if (cached) return cached;
  if (typeof window === 'undefined') return 'web';
  let stored: string | null = null;
  try { stored = sessionStorage.getItem(APP_CHANNEL_KEY); } catch { /* 저장소 거부 */ }
  const ch = detectAppChannel({
    search: typeof location !== 'undefined' ? location.search : '',
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    stored,
  });
  if (ch === 'onestore-twa' && stored !== ch) {
    try { sessionStorage.setItem(APP_CHANNEL_KEY, ch); } catch { /* 이번 계산 캐시만 */ }
  }
  cached = ch;
  return ch;
}

export const isAppChannel = (): boolean => getAppChannel() === 'onestore-twa';

/** 테스트용: 캐시 초기화 */
export function resetAppChannelCache(): void { cached = null; }

export const APP_PAY_NOTICE = '앱에서는 결제를 준비 중입니다';
